export const getCardWidth = (width: number, isPortrait: boolean | undefined): number => {
  let itemsPerRow;
  let gap = 16;
  if (width < 448) {
    itemsPerRow = isPortrait ? 2.25 : 1.6;
  } else if (width < 680) {
    itemsPerRow = 2.25;
  } else if (width < 880) {
    itemsPerRow = 3.15;
  } else if (width < 1400) {
    itemsPerRow = 4.15;
    gap = 20;
  } else {
    itemsPerRow = 6.05;
    gap = 20;
  }

  // Subtract a small value for gap between cards
  return Math.floor(width / itemsPerRow) - gap;
};
